import axios from '../../../services/api';
import { userManagementUrls } from '../projectsKanban/apiUrls';

// Single in-flight promise shared across all concurrent callers
let rolesInFlight: Promise<string[]> | null = null;

export const fetchUserRoles = async (): Promise<string[]> => {
  if (rolesInFlight) return rolesInFlight;

  rolesInFlight = axios
    .get(userManagementUrls.getCurrentRoles)
    .then((response) => response.data || [])
    .catch((error) => {
      console.error('Error fetching user roles', error);
      return [];
    })
    .finally(() => {
      rolesInFlight = null;
    });

  return rolesInFlight;
};
